import { render, staticRenderFns } from "./domicilio.vue?vue&type=template&id=d6af1eaa&scoped=true&"
import script from "./domicilio.component.ts?vue&type=script&lang=ts&"
export * from "./domicilio.component.ts?vue&type=script&lang=ts&"
import style0 from "./domicilio.vue?vue&type=style&index=0&id=d6af1eaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6af1eaa",
  null
  
)

export default component.exports